var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStepStartreset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 2H10.8889V13.1111H13.1111V2ZM18.4778 4.41111L16.9 5.98889C18.6556 7.4 19.7778 9.56667 19.7778 12C19.7778 16.3 16.3 19.7778 12 19.7778C7.7 19.7778 4.22222 16.3 4.22222 12C4.22222 9.56667 5.34444 7.4 7.08889 5.97778L5.52222 4.41111C3.36667 6.24444 2 8.95556 2 12C2 17.5222 6.47778 22 12 22C17.5222 22 22 17.5222 22 12C22 8.95556 20.6333 6.24444 18.4778 4.41111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStepStartreset);
export default __webpack_public_path__ + "static/media/icon_step_startreset.76d0d5fd6288ddec76324cf51ce7509f.svg";
export { ForwardRef as ReactComponent };